import React from "react";
import HistoryPageSection from "../sections/HistoryPageSection/Content";
const HistoryPage = () => {
  return <HistoryPageSection />;
};

export default HistoryPage;
